import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
	selector: "stages-proxy",
	templateUrl: "./proxy.component.html",
	imports: [RouterOutlet],
})
export class ProxyComponent {}
